/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateGoogleDriveAppInput = {
    gdriveEnabled?: boolean | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type updateGoogleDriveMutationVariables = {
    input: UpdateGoogleDriveAppInput;
};
export type updateGoogleDriveMutationResponse = {
    readonly updateGoogleDriveApp: {
        readonly company: {
            readonly id: string;
            readonly gdriveEnabled: boolean | null;
        } | null;
    } | null;
};
export type updateGoogleDriveMutation = {
    readonly response: updateGoogleDriveMutationResponse;
    readonly variables: updateGoogleDriveMutationVariables;
};



/*
mutation updateGoogleDriveMutation(
  $input: UpdateGoogleDriveAppInput!
) {
  updateGoogleDriveApp(input: $input) {
    company {
      id
      gdriveEnabled
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateGoogleDriveAppInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateGoogleDriveAppPayload",
    "kind": "LinkedField",
    "name": "updateGoogleDriveApp",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gdriveEnabled",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateGoogleDriveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateGoogleDriveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateGoogleDriveMutation",
    "operationKind": "mutation",
    "text": "mutation updateGoogleDriveMutation(\n  $input: UpdateGoogleDriveAppInput!\n) {\n  updateGoogleDriveApp(input: $input) {\n    company {\n      id\n      gdriveEnabled\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '227b5a2f1343775ef96144ffb35e8289';
export default node;
